import { app } from '../../../../../app';
import { Controller } from './directory.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectory', {
    bindings: {
        directories: '<',
        directory: '<',
        domains: '<',
    },
    controller: Controller,
    templateUrl: require('./directory.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/directory.component.js